import React, { useEffect, useState } from "react";
import "./EnvComponent.scss"; // Import SCSS file
import Home from "../Home/Home";
import { CartData } from "../../interfaces/CartData";
import { useNavigate } from "react-router-dom";
import { useHeaderMenu, readLoginSession, writeLoginSession } from "../../contexts/login.context";
import useLoader from '../../contexts/LoaderContext';
import Spinner from "../Spinner/Spinner";
import { useTranslation } from "react-i18next";
import nvCookieHelpers from "../../services/cookieService";
import { useCart } from "../../services/cartService";
import { config } from "../../config";
import { useAuth } from '../../services/authService';
import { jwtDecode } from "jwt-decode";

const EnvComponent = () => {
  const [data, setData] = useState<CartData | null>(null);
  const locale = window.location.pathname.split('/')[1];
  const { showLoader, hideLoader, isLoading, hideBodyLoader } = useLoader();
  const { setIsDownload, setCartCategory, setItemsInCart, setLoginStatus } = useHeaderMenu();
  const { getCart } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { HandleSSOLogin } = useAuth();
  const [loggedIn, setLoggedIn] = useState(false);
  const registeredShopperAPI = config.registeredShopperAPI;
  const emptyCart = (msg, pid?) => navigate(`/${locale}/software/cart/empty`, { state: { msg, pid } });
  const handleSuccess = async (result, pid?) => {
    let resultLength = Object.keys(result.cartItems).length
    if (result && resultLength > 0) {
      setData(result)
      setIsDownload(result.isDigital);
      setCartCategory(result.category?.toUpperCase() ?? '');

      try {


        let hintEmail: string | undefined = undefined;
        const hasRegisteredToken = Boolean(result.idt);
        setLoginStatus(hasRegisteredToken);

        if (result.category === 'DLI') {
          hintEmail = nvCookieHelpers.getCookie('dli_marketplace_id')?.replace(/^"|"$/g, '');
          if (hintEmail && hintEmail.length > 0 && !hasRegisteredToken) {
            window.location.href = config.bcSSOLoginUrl.replace('/authorize?', `/authorize?login_hint=${hintEmail}&`) + `${locale}/software/cart`;
          } else if (!hasRegisteredToken) {
            window.location.href = config.bcSSOLoginUrl.replace('/authorize?', `/authorize?`) + `${locale}/software/cart`;
          }
        } else if (result.category === 'ACADEMY') {
          // Await the async readLoginSession call
          const readSession = await readLoginSession();
          console.log('readSession===>', readSession);

          // Parse the session data if it's a JSON string
          const parsedSession = typeof readSession === 'string'
            ? JSON.parse(readSession)
            : readSession;
          console.log('Parsed Session Data:', parsedSession);
          hintEmail = parsedSession?.payload?.login_hint;

          if (result.emailAddress && result.emailAddress.length > 0 && !(parsedSession?.payload)) {
            // Write operation (fire and forget - doesn't return a promise)
            const token = result.idt;
            const decoded = jwtDecode(token);
            console.log(decoded);
            const timestamp = decoded['updated_at']; // seconds
            const date = new Date(timestamp * 1000);
            const timestampISO = date.toISOString();
            writeLoginSession(decoded['email'], decoded['idp_id'], timestampISO, decoded['sub'] || '');
            console.log('writeSession called');
          }
          if (hintEmail && hintEmail.length > 0 && !hasRegisteredToken) {
            window.location.href = config.bcSSOLoginUrl.replace('/authorize?', `/authorize?login_hint=${hintEmail}&`) + `${locale}/software/cart`;
          }
        }

        if (hasRegisteredToken) {
          setLoggedIn(true);
        }
      } catch (error) {
        console.error('Error reading login session:', error);
        hideLoader();
      }
    }
  }
  const handleError = (str: string, pid?: number) => {
    if (pid) {
      if (str && str.length) {
        emptyCart(str, pid);
      } else {
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), pid);
      }
    } else {
      emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
    }
    setItemsInCart(0);
    hideBodyLoader();
  };

  const handleSubmit = (btnType: string) => {
    if (btnType) {
      navigate(`/${locale}/software/cart/user/${btnType}`);
      sessionStorage.setItem('customer', btnType);
    } else {
      // Navigate to another route
      navigate(`/${locale}/software/cart/`);
    }
  };
  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        fetch(registeredShopperAPI, {
          credentials: 'include',
        }).then(async (res) => {
          await HandleSSOLogin(handleSubmit, () => { })
          await getCart(handleSuccess, handleError);
          hideLoader();
        });
      } catch (error) {
        console.error(error);
        //hideLoader();
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
      }
    }
    if (!data) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="env-component">
      {
        isLoading ? (
          <Spinner />
        ) : (
          <div className="viewPage">
            {data && (
              <Home cartData={data} loggedIn={loggedIn} />
            )}
          </div>
        )}
    </div>
  );

}

export default EnvComponent;
